<template>

			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Tambah Saldo</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Nama Admin</label>
                                                <input type="text" class="form-control" placeholder="Nama Area..." disabled v-model="data.nama">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Tambah Saldo (Pastikan tidak pakai titik/koma. Mis : 50000)</label>
                                                <input type="number" class="form-control" placeholder="Tarif Paket..." v-model="tambah.form.jumlah">
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary" @click="tambah.submit()" v-show="data.btn">Simpan</button>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
	const data = reactive({
		id: "",
		nama: "",
        btn: true
    })

	const tambah = {
      	form: reactive({
		    jumlah: ""
      	}),
		submit() {
            data.btn = false;

			var datax = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
          		id: data.id, // id kang voucher
          		jumlah: this.form.jumlah
        	};
				
			var apiUrl = inter.kangVoucherTambahSaldo();
			myGlobal.call(datax,apiUrl).then(x => {
				console.log(JSON.stringify(x));
				if (x.status == true) {
                    location.href="#/kang-voucher"
				} else {
					//alert(x.pesan);
				}
			})
		}
    }
    return {
      data, 
      tambah
    }

  },
  mounted () {
    document.title = "Tambah Saldo Admin Voucher";

    this.data.id = this.$route.params.id;
    this.data.nama = sessionStorage.getItem("VoucherNama");

    //alert(this.data.id);
  }
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/kang-voucher/tambah-saldo.vue